import React from 'react';

import Responsive from '@/components/Responsive';

import ActionButtonDesktop from './index.desktop';
import ActionButtonMobile from './index.mobile';

export type ActionButtonProps = {
  children: string | React.ReactNode;
  isSelected?: boolean;
  isOpen: boolean;
  onClick?: () => void;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  className?: string;
  id?: string; // for automation purpose
};

const ActionButton = React.forwardRef(
  (
    {
      children,
      isSelected = false,
      isOpen,
      onClick,
      endIcon,
      startIcon,
      id,
      className,
    }: ActionButtonProps,
    ref: React.Ref<HTMLButtonElement> | undefined,
  ) => {
    return (
      <Responsive>
        <Responsive.Default>
          <ActionButtonDesktop
            ref={ref}
            className={className}
            endIcon={endIcon}
            id={id}
            isOpen={isOpen}
            isSelected={isSelected}
            startIcon={startIcon}
            onClick={onClick}>
            {children}
          </ActionButtonDesktop>
        </Responsive.Default>
        <Responsive.Tablet>
          <ActionButtonMobile ref={ref} isOpen={isOpen} isSelected={isSelected} onClick={onClick}>
            {children}
          </ActionButtonMobile>
        </Responsive.Tablet>
        <Responsive.Mobile>
          <ActionButtonMobile ref={ref} isOpen={isOpen} isSelected={isSelected} onClick={onClick}>
            {children}
          </ActionButtonMobile>
        </Responsive.Mobile>
      </Responsive>
    );
  },
);

export default ActionButton;
